<template>
  <div>
    <p>
    Aquest model serveix per a generar<strong>portades de perfils de xarxes socials</strong> per a col·lectius locals o comarcals.
    </p>
    <p>
      Recomanem usar una <strong>foto representativa del poble o comarca</strong>, que puga ser reconeguda amb facilitat al costat de logo, per exemple un edifici
      representatiu o un paisatge fàcil de reconéixer.
    </p>
    <p>
      Disposeu dels següents formats:
    </p>
    <ul>
      <li><strong>Facebook</strong></li>
      <li><strong>Twitter</strong>: La portada de twitter està pensada per a que quede la foto de perfil emmarcat dins de les quatribarrada</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/facebook.png" alt="Exemple facebook" />
      <img src="./examples/twitter.jpeg" alt="Exemple twitter" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'cover-help'
}
</script>
